"use client";

/**
 * β-8 v3 — mypage/* 전체 인증 가드 (새로고침 시 안전 redirect).
 * zustand persist hydration 완료 후에만 redirect 결정.
 */
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore } from "@/store/auth";

export default function MypageLayout({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  const hasHydrated = useAuthStore((s) => s._hasHydrated);

  useEffect(() => {
    if (!hasHydrated) return;
    if (!isLoggedIn) router.replace("/login?next=/mypage");
  }, [hasHydrated, isLoggedIn, router]);

  if (!hasHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center gap-2 text-text-sub text-sm">
          <span className="w-4 h-4 border-2 border-text-sub/30 border-t-primary rounded-full animate-spin" />
          <span>로딩 중...</span>
        </div>
      </div>
    );
  }
  if (!isLoggedIn) return null;

  return <>{children}</>;
}
